import React from 'react'

import { Provider } from 'react-redux'
import configureStore from './redux/create'
import { bootstrap } from './redux/modules/bootstrap/actions'
import { initialState as searchInitialState } from './redux/modules/search'

import { searchAppConfig } from './utils/propTypes'

import SearchDashboard from './containers/SearchDashboard'

export default function SearchApp ({ data: { results, ...pagination } = {}, ...appConfig }) {
  const initialState = {
    search: {
      ...searchInitialState,
      ...appConfig,
      results: results || [],
      pagination: pagination || {},
    },
  }

  const { store } = configureStore(initialState)

  store.dispatch(bootstrap())

  return (
    <Provider store={store}>
      <SearchDashboard />
    </Provider>
  )
}

SearchApp.propTypes = searchAppConfig



// WEBPACK FOOTER //
// ./src/SearchApp.js